import { observable } from 'mobx';

export type ShippingElementResponseArgs = {
  id: number;
  category_text: string;
};

export type ShippingElementArgs = {
  id: number;
  categoryText: string;
};

export const convertShippingElementResponseToArgs = (response: ShippingElementResponseArgs) => {
  const args: ShippingElementArgs = {
    id: response.id,
    categoryText: response.category_text
  };
  return args;
};

export default class ShippingElement {
  @observable
  id: number;

  @observable
  categoryText: string;

  constructor(args: ShippingElementArgs) {
    this.id = args.id;
    this.categoryText = args.categoryText;
  }

  get type() {
    return 'shipping';
  }

  get title() {
    return '配送料';
  }

  get summary() {
    return `[配送料]${this.categoryText}`;
  }

  get name() {
    return this.title;
  }

  detail() {
    return '';
  }
}
